import React from 'react';
import './Price.css';

const Price = () => {
  // Pricing plan data with single user prices
  const pricingPlans = [
    {
      id: 'basic',
      name: 'Basic',
      price: '200',
      description: '包含：',
      features: [
        'EzVote 快速投票系統',
        '自動登入登出',
        '一鍵處理憑證',
        '列印多種格式的表決單',
      ],
      buttonText: '升級方案',
      isPopular: false
    },
    {
      id: 'pro',
      name: 'Pro',
      price: '500',
      description: '包含Basic所有功能，並提供：',
      features: [
        'EzStock 零股買賣系統',
        '多帳戶買賣零股',
        '自動處理減資',
      ],
      buttonText: '聯絡銷售',
      isPopular: true
    }
  ];

  return (
    <div className="pricing-container">
      <div className="pricing-header">
        <h1>選擇最適合您的方案</h1>
        {/* <p>我們提供多種靈活的定價方案，滿足您的各種需求</p> */}
      </div>

      {/* Add pricing tabs */}
      <div className="pricing-tabs">
        <div 
          className="pricing-tab active"
        >
          單一使用者
        </div>
      </div>

      <div className="pricing-plans">
        {pricingPlans.map((plan) => (
          <div 
            key={plan.id} 
            className={`pricing-card ${plan.isPopular ? 'popular' : ''}`}
          >
            {plan.isPopular && <div className="popular-badge">最受歡迎</div>}
            <div className="plan-name">{plan.name}</div>
            <div className="plan-price">
              <span className="currency">NT$</span>
              <span className="amount">{plan.price}</span>
              <span className="period">/年</span>
            </div>
            <div className="plan-description">{plan.description}</div>
            <div className="plan-features">
              <ul>
                {plan.features.map((feature, index) => (
                  <li key={index}>
                    <span className="feature-icon">✓</span> {feature}
                  </li>
                ))}
              </ul>
            </div>
            <button className="plan-button">{plan.buttonText}</button>
          </div>
        ))}
      </div>

      <div className="pricing-faq">
        <h2>常見問題</h2>
        <div className="faq-item">
          <h3>有提供試用期嗎？</h3>
          <p>我們為Basic和Pro方案提供14天的免費試用期，讓您體驗所有功能。</p>
        </div>
        <div className="faq-item">
          <h3>可以隨時更換方案嗎？</h3>
          <p>是的，您可以隨時升級或降級您的方案。費用將按比例計算。</p>
        </div>
        <div className="faq-item">
          <h3>如何取消訂閱？</h3>
          <p>您可以在帳戶設定中隨時取消訂閱，無需額外費用。</p>
        </div>
      </div>
    </div>
  );
};

export default Price; 